import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'updateDatabase',
        url: '/updateDatabase',
        component: 'wtUpdateDatabaseState',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.administrator])
        },
        data: {
            visible: false,
            sortingOrder: 13,
            icon: 'fa-level-up',
            displayName: 'Database update',
            permission: {
                user: 'administrator'
            },
            editButtonVisibility: () => false,
        }
    }];

export default states;